<template lang="pug">
    .cp-qd
        .page1
          .wrap.procuct-header
            .left-wrap
              p “去电”数智化用户经营平台
              p 体验真实、千人千面的用户经营策略，低成本、高效率的企业客户运营专家
          product-list1(type="mp")
        content-list(:list="list")
        apply-list(:info="applyInfo", :img="applyImg", :logoList="logoList", @showModal="showModal")
        page-belt(:beltType="1" @showModal="showModal")
</template>
<script>
import productList1 from './components/product-list1'
import contentList from './components/content-list'
import applyList from './components/apply-list'

export default {
  components: {
    productList1,
    contentList,
    applyList,
  },
  props: {},
  data () {
    return {
      list: [
        { title: 'AI任务', content: '一键创建外呼任务，定时定量精准触发', labels: ['操作简单', '敏捷省心', '便捷管理'], imgSrc: require('@/assets/ai-task.png') },
        { title: '自然沟通', content: 'AI话务员与用户自然沟通', labels: ['甜美原声', '智能打断', '无感转接'], imgSrc: require('@/assets/nature-call.png') },
        { title: '通话记录', content: '通话过程完整记录，99%精准度语音转写，准确复现对话过程', labels: ['通过过程详细语音', '精准转写的语义文字', '通话场景准确还原'], imgSrc: require('@/assets/call-record.png') },
        { title: '短信记录', content: '业务短信紧跟用户挂机动作无缝送达，抓住一手商机', labels: ['自定义业务短信', '挂机无缝送达', '一手商机立刻转化'], imgSrc: require('@/assets/sms-record.png') },
      ],
      applyInfo: {
        titles: ['用户转化', '意向筛选', '业务推介'],
        content: '触达用户的速度、广度和精准度决定了业务的效率和转化率。去电AI话务员能依据平台指令第一时间向海量意向客户发起智能语音互动，声音甜美，逻辑清晰，依据客户需求智能推荐业务，做到千人千面，高效转化。'
      },
      applyImg: { src: require('../../assets/apply1.png'), style: 'width: 488px' },
      logoList: [
        { src: require('../../assets/apply-zhongan.png'), style: 'width: 108px' },
        { src: require('../../assets/apply-zhongxin.png'), style: 'width: 106px' },
        { src: require('../../assets/apply-huanbei.png'), style: 'width: 51px' },
      ]
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
      <style lang="stylus">
      @import './config'
      .cp-qd
        .page1
          padding-top $topbar-height
          background #0a1e50
          .procuct-header
            height 580px
            background: url("../../assets/aiCallbot-banner.jpg") center no-repeat
            background-size: cover;
            margin-bottom -121px
            margin-top -94px
          .wrap
            position relative
            .left-wrap
              position absolute
              padding-top 178px
              left 20%
              width 430px
              p
                &:first-child
                  font-size 36px
                  margin-bottom 15px
                &:nth-child(2)
                  font-size 16px
                  color #D5DCEC
              .banner-btn
                margin-top 38px
          .banner-wrap
            position relative
      </style>
